// squareChart component
// import ref from './_state';
import squareChart from './chart-square';

// pass in squareChart object literal
export default function (ref, opts) {

    let dataValue = ref.data[ref.activeIndex][opts.key];

    let chart = squareChart()
        .dataValue(dataValue)
        .dataMin(ref.minMaxValues[opts.key][0])
        .dataMax(ref.minMaxValues[opts.key][1])
        .margin({top:5, right:5, bottom:5, left:0})
        .height(90)
        .bColour('#b3b8bd')
        .fColour(opts.fColour);

    // don't send null values to square chart
    if (_.isNull(dataValue) || _.isUndefined(dataValue)) {
        dataValue = 0;
        // don't display data rect
        chart.display(false);

        ref.dom.select(opts.id)
            .call(chart);

    } else {
        chart.display(true);

        ref.dom.select(opts.id)
            .call(chart);
    }


}